import {
  APP_COLOR_SCHEME_ATTRIBUTE,
  DEFAULT_THEME_PREFERENCE,
  PREFERENCE_TO_MUI_SCHEME,
  THEME_COLOR_SCHEME_STORAGE_KEY,
  THEME_MODE_STORAGE_KEY,
  THEME_PREFERENCE_KEY,
} from "../../styles/theme-mode-config"

export default function InitAppColorSchemeScript() {
  const preferenceKey = THEME_PREFERENCE_KEY
  const defaultPreference = DEFAULT_THEME_PREFERENCE
  const attr = APP_COLOR_SCHEME_ATTRIBUTE
  const modeKey = THEME_MODE_STORAGE_KEY
  const colorSchemeKey = THEME_COLOR_SCHEME_STORAGE_KEY

  const devWarn =
    process.env.NODE_ENV !== "production"
      ? "console.warn('InitAppColorSchemeScript:', e);"
      : ""

  // Duplicates seedMuiColorSchemeStorage() (root.jsx): this blocking script is what other open tabs pick up via a storage event.
  const script = `
    (function() {
      try {
        var pref = localStorage.getItem('${preferenceKey}') || '${defaultPreference}';
        var map = ${JSON.stringify(PREFERENCE_TO_MUI_SCHEME)};
        var muiMode = map[pref];
        var scheme = muiMode;
        if (pref === 'system') {
          scheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }
        if (scheme) {
          document.documentElement.setAttribute('${attr}', scheme);
        }
        if (muiMode && localStorage.getItem('${modeKey}') !== muiMode) {
          localStorage.setItem('${modeKey}', muiMode);
        }
        if (muiMode === 'light' || muiMode === 'system') {
          if (localStorage.getItem('${colorSchemeKey}-light') !== 'light') {
            localStorage.setItem('${colorSchemeKey}-light', 'light');
          }
        }
        if (muiMode === 'dark' || muiMode === 'system') {
          if (localStorage.getItem('${colorSchemeKey}-dark') !== 'dark') {
            localStorage.setItem('${colorSchemeKey}-dark', 'dark');
          }
        }
      } catch (e) {
        ${devWarn}
      }
    })();
    `

  return (
    <script
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: script }}
    />
  )
}
